import React from "react";
import { Box, Typography, Divider } from "@mui/material";

const SectionTitle = ({ title, subtitle }) => (
  <Box mb={3}>
    <Typography variant="h6" fontWeight={600}>
      {title}
    </Typography>
    {subtitle && (
      <Typography variant="body2" color="text.secondary" mt={0.5}>
        {subtitle}
      </Typography>
    )}
    <Divider sx={{ mt: 1.5 }} />
  </Box>
);

export default SectionTitle;